import ButtonCta from '@components/atoms/button-cta'
import { TimelineArrow } from '@components/atoms/icons'
import Image from '@components/atoms/image'
import SliderNew from '@components/slider-new/index'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import { RenderRichText } from '@components/renderers/index'
import PropTypes from 'prop-types'
import useStyles from './timeline.styles'

const Timeline = (props) => {
  const {
    events,
    header,
    supportText,
    supportRichText,
    backgroundImage,
    wrap,
    ctaText,
    ctaLink,
    timelineStyle = true,
  } = props
  const styles = useStyles({ backgroundImage, wrap })
  const config = {
    initial: 0,
    mode: 'snap',
    breakpoints: {
      '(min-width: 200px)': {
        loop: false,
        slides: { perView: 1, spacing: 500 },
      },
    },
  }

  return (
    <div className={styles.root}>
      <div className={styles.backgroundOverlay} />
      <Container className={styles.content}>
        <div className={styles.titleContainer}>
          <div className={styles.titleTextWrapper}>
            {header && <Typography variant="h2">{header}</Typography>}
            {supportText && <Typography variant="body1" className={styles.supportText}>{supportText}</Typography>}
            {!supportText && supportRichText && (
              <div className={styles.richTextWrapper}>
                <RenderRichText {...supportRichText} />
              </div>
            )}
          </div>
          {(ctaText && ctaLink) && (
            <ButtonCta
              className={styles.ctaButton}
              href={ctaLink}
              variant="contained"
              color="primary"
            >{ctaText}
            </ButtonCta>
          )}
        </div>
        <div className={`${styles.eventCardContainer} ${!timelineStyle ? styles.centered : null}`}>
          {events.map((event, index) => (
            <div className={styles.eventCard} key={event.title}>
              {event?.logo?.url && (
                <div className={styles.logos}>
                  <Image src={`${event.logo.url}`} alt="" />
                  {(index + 1 !== events.length) && timelineStyle ? <TimelineArrow className={styles.arrow} width="52.42" height="12.65" /> : null}
                </div>
              )}
              <div className={styles.textContainer}>
                <div className={styles.yearTitleContainer}>
                  {event.eventYear && <Typography variant="overline">{event.eventYear}</Typography>}
                  {event.title && <Typography variant="h6">{event.title}</Typography>}
                </div>
                {event.eventRichText
                  ? <RenderRichText {...event.eventRichText} />
                  : <Typography className={styles.description} variant="body1">{event.eventHeadline}</Typography>}
                {
                  event.relevantStoriesCtaLink && (
                    <ButtonCta
                      variant="text"
                      size="small"
                      arrow
                      className={styles.button}
                      href={event.relevantStoriesCtaLink}
                    >
                      {event.relevantStoriesCtaText}
                    </ButtonCta>
                  )
                }
              </div>
            </div>
          ))}
        </div>

        <div className={styles.sliderContainer}>
          <div className={styles.slider}>
            <SliderNew
              controlClassName={styles.customControl}
              config={config}
            >
              {events.map(event => (
                <div className={styles.eventCard} key={event.title}>
                  {event?.logo?.url && (
                    <div className={styles.logos}>
                      <Image src={`${event.logo.url}`} alt="" />
                    </div>
                  )}
                  <div>
                    <div className={styles.yearTitleContainer}>
                      {event.eventYear && <Typography variant="overline">{event.eventYear}</Typography>}
                      {event.title && <Typography variant="h5">{event.title}</Typography>}
                    </div>
                    {event.eventHeadline && <Typography variant="body1">{event.eventHeadline}</Typography>}
                    {
                      event.relevantStoriesCtaLink && (
                        <ButtonCta
                          variant="text"
                          size="small"
                          arrow
                          className={styles.button}
                          href={event.relevantStoriesCtaLink}
                        >
                          {event.relevantStoriesCtaText}
                        </ButtonCta>
                      )
                    }
                  </div>
                </div>
              ))}
            </SliderNew>
          </div>
        </div>
      </Container>
    </div>
  )
}

Timeline.propTypes = {
  events: PropTypes.array,
  header: PropTypes.string,
  supportText: PropTypes.string,
  supportRichText: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  backgroundImage: PropTypes.object,
  wrap: PropTypes.bool,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  timelineStyle: PropTypes.bool,
}

export default Timeline
